import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { ErrorComponent } from "@workspace/ui/components/error-component";

import { PageLoadingFull } from "@/components/page-loading";

export const Route = createFileRoute("/_auth")({
	beforeLoad: ({ context, location }) => {
		if (!context.auth.isAuthenticated) {
			throw redirect({
				to: "/login",
				search: {
					redirect: location.href,
				},
				statusCode: 401,
			});
		}
	},
	component: AuthLayout,
	pendingComponent: PageLoadingFull,
	errorComponent: ErrorComponent,
});

function AuthLayout() {
	return <Outlet />;
}
